import Axios from "axios";
import { showMessage } from "jd-library/src/Toast/ToastAction";
import { getStore } from "../../../../store/createStore";
import { showHideLoader } from "../../../actions";
import { categoryMissingDataFetched, clickTrack, toggleCategoryMissingCardSlider, toggleCategoryMissingCardSliderPersist } from "../../../actions/products";

export const getCategoryMissingCardData = async (isFromCard = false, isLastProd = false) => {
    const dispatch = getStore().dispatch;
    const state = getStore().getState();
    !isFromCard && dispatch(clickTrack({ ll: 'digital_catalog', li: 'missing_products', userBasedCheck: true }));
    dispatch(showHideLoader({ showLoader: true }));
    const { docId, profileObject } = state.session;
    try {
        const apiRes = await Axios.get(`/vendorapis/products/inventory/getProductCountAgainstJdmartid?docid=${docId}&from=smartcard`);
        const data = apiRes.data
        if (data.errors.code == 0 && data.data.nonexisting_jdmartid) {
            const categoryData = data.data.nonexisting_jdmartid
            if (!categoryData.length && !isLastProd) {
                dispatch(showMessage({
                    showToastMessage: true,
                    message: `No Categories without ${profileObject.PluralLabelWithSpace} Found.`,
                    type: 'info',
                    duration: 5000
                }));
            }
            dispatch(categoryMissingDataFetched(categoryData));
            dispatch(showHideLoader({ showLoader: false }));
            if (!isFromCard) {
                dispatch(toggleCategoryMissingCardSlider(true));
                dispatch(toggleCategoryMissingCardSliderPersist(true));
            }
        } else {
            dispatch(showMessage({
                showToastMessage: true,
                message: data.errors?.msg || 'Unable to Fetch Category. Please try again after some time.',
                type: 'info',
                duration: 5000
            }));
            dispatch(showHideLoader({ showLoader: false }));
        }
    } catch (error) {
        dispatch(showMessage({
            showToastMessage: true,
            message: error?.message || 'Something went wrong, Please try again.',
            type: 'info',
            duration: 5000
        }));
        dispatch(showHideLoader({ showLoader: false }));
    }
}

export const updateCategoryMissingCardData = async (jdmartid, isLastProd = false) => {
    try {
        const state = getStore().getState();
        const { docId } = state.session;
        const rsp = await Axios.get(`/vendorapis/products/inventory/deleteNcatidAgainstJdmartid?docid=${docId}&jdmid=${jdmartid}`);
        const res = rsp.data
        if (res?.status) {
            getCategoryMissingCardData(true, isLastProd)
            return { success: true, error: "" }
        } else {
            return { success: false, error: res?.message || res?.msg || "Something went wrong" }
        }
    } catch (err) {
        return { success: false, error: err?.message || err?.msg || "Something went wrong" }
    }
}

export const debounceFunc = (func, delay) => {
    let timeoutId;
    return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func(...args);
        }, delay);
    };
}

export const charFromWords = (word, isTwoWord = false) => {
    if (isTwoWord) {
        const newAry = word.split(" ")
        if(newAry.length > 1){
            return newAry[0].charAt(0) + newAry[1].charAt(0)
        }else{
            return newAry[0].charAt(0)
        }
    } else {
        return word.charAt(0)
    }
}